export default __webpack_public_path__ + "d0668dea21b67e692f4a54bdd0e4cec1.svg";